module.exports = __webpack_public_path__ + "img/homelsty.c5a16783.png";